/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseMCPCallArgumentsDoneEvent = {
  type: "response.mcp_call_arguments.done";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  arguments: string;
};

/** @internal */
export const ResponseMCPCallArgumentsDoneEvent$inboundSchema: z.ZodType<
  ResponseMCPCallArgumentsDoneEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.mcp_call_arguments.done"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  arguments: z.string(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseMCPCallArgumentsDoneEvent$Outbound = {
  type: "response.mcp_call_arguments.done";
  sequence_number: number;
  item_id: string;
  output_index: number;
  arguments: string;
};

/** @internal */
export const ResponseMCPCallArgumentsDoneEvent$outboundSchema: z.ZodType<
  ResponseMCPCallArgumentsDoneEvent$Outbound,
  z.ZodTypeDef,
  ResponseMCPCallArgumentsDoneEvent
> = z.object({
  type: z.literal("response.mcp_call_arguments.done"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  arguments: z.string(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseMCPCallArgumentsDoneEventToJSON(
  responseMCPCallArgumentsDoneEvent: ResponseMCPCallArgumentsDoneEvent,
): string {
  return JSON.stringify(
    ResponseMCPCallArgumentsDoneEvent$outboundSchema.parse(
      responseMCPCallArgumentsDoneEvent,
    ),
  );
}
export function responseMCPCallArgumentsDoneEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseMCPCallArgumentsDoneEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseMCPCallArgumentsDoneEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseMCPCallArgumentsDoneEvent' from JSON`,
  );
}
